import * as React from 'react';
import 'react-markdown-editor-lite/lib/index.css';
import MarkdownParser from '../utils/MarkdownParser';

import MdEditor from 'react-markdown-editor-lite';
import {useAxios} from '../utils/AxiosProvider';
export default function ExMdEditor(props: {value?: string; onChange?: (text: string) => any; height?: string}) {
  const mdParser = MarkdownParser;
  const axois = useAxios();
  function handleImageUpload(file: any, callback: any) {
    const reader = new FileReader();
    reader.onload = async () => {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axois.instance.post<{url: string}>('image/upload', formData);
      const uploadedUrl = res.data.url;
      callback(uploadedUrl);
    };
    reader.readAsDataURL(file);
  }
  return (
    <MdEditor
      value={props.value}
      style={{height: props.height || '600px'}}
      renderHTML={text => mdParser.render(text)}
      htmlClass={'markdown-here-wrapper'}
      onChange={({text}) => {
        if (props.onChange) props.onChange(text);
      }}
      config={{
        view: {
          menu: true,
          md: true,
          html: true,
          fullScreen: true,
        },
        imageUrl: 'https://octodex.github.com/images/minion.png',
      }}
      onImageUpload={(file, callback) => handleImageUpload(file, callback)}
    />
  );
}
